module.exports = __webpack_public_path__ + "static/1343203373-wide.72a99810.jpg";